import { useRef } from "react";
import { AbortableRequestsContext, AbortableRequestsContextType } from "./AbortableRequestsContext";
import { ObservableSubscription } from "@apollo/client";

export const AbortableRequestsProvider: React.FCWithChildren = ({ children }) => {
    const observables = useRef<{ [key: string]: ObservableSubscription | null }>({});

    const setAbortableRequest: AbortableRequestsContextType["setAbortableRequest"] = (channel, id, request) => observables.current[`${channel}-${id}`] = request;
    const abortPendingRequest: AbortableRequestsContextType["abortPendingRequest"] = (channel, id) => observables.current[`${channel}-${id}`]?.unsubscribe();

    return (
        <AbortableRequestsContext.Provider value={{ setAbortableRequest, abortPendingRequest }}>
            {children}
        </AbortableRequestsContext.Provider>
    );
};
